import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Activity, WorkflowStepInterface } from '@vendasta/automata';
import { map, switchMap, take } from 'rxjs/operators';
import { DisplayService } from '../../automation-editor/components/common/display.service';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { CurrentAutomationService } from '@galaxy/automata/shared';

interface ActivityRow {
  activity: Activity;
}

@Component({
  selector: 'automata-step-cell',
  template: `
    <ng-container *ngIf="displayContent$ | async as displayContent; else loading">
      <div class="title" [innerHtml]="displayContent.title"></div>
      <div class="subtitle" [innerHtml]="displayContent.subtitle"></div>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  `,
  styleUrls: ['./automata-cells.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, GalaxyPipesModule],
})
export class StepCellComponent implements OnInit {
  @Input() element: ActivityRow;

  displayContent$: Observable<{
    title: string;
    subtitle: string;
  }>;
  title$: Observable<string>;
  subtitle$: Observable<string>;

  step: WorkflowStepInterface;

  constructor(
    private readonly currentAutomationService: CurrentAutomationService,
    private readonly displayService: DisplayService,
  ) {}

  ngOnInit(): void {
    this.title$ = this.currentAutomationService.automation$.pipe(
      switchMap((a) => this.displayService.getActionTitle(a.namespace, this.element.activity.workflowStep)),
    );
    this.subtitle$ = this.currentAutomationService.automation$.pipe(
      switchMap((a) =>
        this.displayService.getActionSubtitle(
          a.namespace,
          this.element.activity.workflowStep?.taskDefinitionId,
          this.element.activity.workflowStep,
          a,
        ),
      ),
    );
    this.displayContent$ = combineLatest([this.title$, this.subtitle$]).pipe(
      take(1),
      map(([title, subtitle]) => ({
        title: title,
        subtitle: subtitle,
      })),
    );
  }
}
